import { VendorCompanyCode } from '@controlling/vendor-company-code/vendor-company-code';
import { VendorContact } from '@controlling/vendor-contact/vendor-contact';
import { VendorContractType } from '@controlling/vendor-contract-type/vendor-contract-type';
import { VendorDetail } from '@controlling/vendor-detail/vendor-detail';
import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { LogisticsMainTruckCount } from '../logistics-main-truck-count/logistics-main-truck-count';
import { LogisticsTruckCount } from '../logistics-truck-count/logistics-truck-count';
import { VendorConstraintsPerRegion } from '../vendor-constraints-per-region/vendor-constraints-per-region';
FieldBuilder.setNamespace('Controlling');

export const VENDOR_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('sapCode', 'Entity.Vendor.SapCode')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('legalName', 'Entity.Vendor.LegalName')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('fantasyName', 'Entity.Vendor.FantasyName')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('vatNumber', 'Entity.Vendor.VatNumber')
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('taxNumber', 'Entity.Vendor.TaxNumber')
    .maxLength(11)
    .build(),
  FieldBuilder
    .text('taxType', 'Entity.Vendor.TaxType')
    .maxLength(20)
    .build(),
  FieldBuilder
    .checkbox('isSapDeleted', 'Entity.Vendor.IsSapDeleted')
    .build(),
  FieldBuilder
    .checkbox('isGenericVendor', 'Entity.Vendor.IsGenericVendor')
    .build(),
  FieldBuilder
    .checkbox('isOwnService', 'Entity.Vendor.IsOwnService')
    .build(),
  FieldBuilder
    .checkbox('shouldAskForActivityReportAuthorization', 'Entity.Vendor.ShouldAskForActivityReportAuthorization')
    .build(),
  FieldBuilder
    .text('industryKey', 'Entity.Vendor.IndustryKey')
    .maxLength(4)
    .build(),
  FieldBuilder
    .text('businessType', 'Entity.Vendor.BusinessType')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('operationDgiId', 'Entity.Vendor.OperationDgiId')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('receptionAddress', 'Entity.Vendor.ReceptionAddress')
    .maxLength(100)
    .build(),
  FieldBuilder
    .checkbox('isDosesVendor', 'Entity.Vendor.IsDosesVendor')
    .build(),
  FieldBuilder
    .text('oldSapCode', 'Entity.Vendor.OldSapCode')
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('isMainVendor', 'Entity.Vendor.IsMainVendor')
    .build(),
  FieldBuilder
    .text('nameInitials', 'Entity.Vendor.NameInitials')
    .maxLength(3)
    .build(),
];

export const VENDOR_CONFIG = {
  entityName: 'Vendor',
  localizationKey: 'Controlling::Entity.Vendor',
  fields: VENDOR_FIELDS,
  permission: 'ControllingContract.Vendors',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'VendorDetail',
      foreignKeyField: 'vendorId',
      localizationKey: 'Controlling::Entity.VendorDetail',
      component: VendorDetail,
    },
    {
      entityName: 'VendorContact',
      foreignKeyField: 'vendorId',
      localizationKey: 'Controlling::Entity.VendorContact',
      component: VendorContact,
    },
    {
      entityName: 'VendorContractType',
      foreignKeyField: 'vendorId',
      localizationKey: 'Controlling::Entity.VendorContractType',
      component: VendorContractType,
    },
    {
      entityName: 'VendorCompanyCode',
      foreignKeyField: 'vendorId',
      localizationKey: 'Controlling::Entity.VendorCompanyCode',
      component: VendorCompanyCode,
    },
  
    {
      entityName: 'LogisticsMainTruckCount',
      foreignKeyField: 'vendorId',
      localizationKey: 'Controlling::Entity.LogisticsMainTruckCount',
      component: LogisticsMainTruckCount,
    },
    {
      entityName: 'LogisticsTruckCount',
      foreignKeyField: 'vendorId',
      localizationKey: 'Controlling::Entity.LogisticsTruckCount',
      component: LogisticsTruckCount,
    },
    {
      entityName: 'VendorConstraintsPerRegion',
      foreignKeyField: 'vendorId',
      localizationKey: 'Controlling::Entity.VendorConstraintsPerRegion',
      component: VendorConstraintsPerRegion,
    },
  ]
};
